// extracted by mini-css-extract-plugin
module.exports = {"container":"styles_container__2lYM4","numbersContainer":"styles_numbersContainer__1kJm5","card":"styles_card__2KhIx"};